import React from "react"
import { CTAContainer } from "./style"
import { FlexGrid, FlexRow, FlexCol } from "components/FlexGrid"

const CTAModule = ({ data, pageColor }) => {
  let color = "neutral"

  if (pageColor === "pink") {
    color = "yellow"
  }
  if (pageColor === "yellow") {
    color = "blue"
  }

  if (pageColor === "blue") {
    color = "purple"
  }

  if (pageColor === "purple") {
    color = "green"
  }

  if (pageColor === "neutral") {
    color = "neutral"
  }

  if (pageColor === "carolinaBlue") {
    color = "carolinaBlue"
  }
  return (
    <CTAContainer color={color}>
      <FlexGrid gap={[0, 20]}>
        <FlexRow>
          <FlexCol xs={12} md={4}>
            <h2>{data.title}</h2>
          </FlexCol>

          <FlexCol
            xs={12}
            md={8}
            dangerouslySetInnerHTML={{ __html: data.body }}
          />
        </FlexRow>
      </FlexGrid>
    </CTAContainer>
  )
}

export default CTAModule
